export default __webpack_public_path__ + "static/media/7524_144265.e26811fc.svg";